export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/worldWide.aaeb4920.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};